"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
const selector_1 = require("../../../composite/form/selectors/selector");
const form_text_area_1 = require("../../../composite/form/fields/form-text-area");
const form_editor_1 = require("../../../composite/form/fields/form-editor");
const form_time_field_1 = require("../../../composite/form/fields/form-time-field");
const form_checkbox_1 = require("../../../composite/form/fields/form-checkbox");
const form_local_date_time_field_1 = require("../../../composite/form/fields/form-local-date-time-field");
const form_local_date_field_1 = require("../../../composite/form/fields/form-local-date-field");
const form_instant_field_1 = require("../../../composite/form/fields/form-instant-field");
const internal_settings_types_1 = require("./internal-settings-types");
function InternalSettingsDialog() {
    const inputType = selector_1.useFormSelector((data) => data.inputType);
    const ValueComponent = deriveValueComponent(inputType);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__NAME", defaultMessage: "N\u00E1zev" }), disabled: true }),
        react_1.default.createElement(ValueComponent, { name: "value", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__VALUE", defaultMessage: "Hodnota" }) }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "comment", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__COMMENT", defaultMessage: "Koment\u00E1\u0159" }) }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "description", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__DESCRIPTION", defaultMessage: "Popis" }), disabled: true }),
        react_1.default.createElement(form_instant_field_1.FormInstantField, { name: "updated", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__updated", defaultMessage: "Datum editace" }), disabled: true })));
}
exports.InternalSettingsDialog = InternalSettingsDialog;
const deriveValueComponent = (inputType) => {
    switch (inputType === null || inputType === void 0 ? void 0 : inputType.name) {
        case internal_settings_types_1.SimpleEasSettingInputType.SINGLE_LINE_STRING:
            return form_text_field_1.FormTextField;
        case internal_settings_types_1.SimpleEasSettingInputType.MULTI_LINE_STRING:
            return form_text_area_1.FormTextArea;
        case internal_settings_types_1.SimpleEasSettingInputType.CHECKBOX:
            return form_checkbox_1.FormCheckbox;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE:
            return form_local_date_field_1.FormLocalDateField;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE_TIME:
            return form_local_date_time_field_1.FormLocalDateTimeField;
        case internal_settings_types_1.SimpleEasSettingInputType.INSTANT:
            return form_instant_field_1.FormInstantField;
        case internal_settings_types_1.SimpleEasSettingInputType.TIME:
            return form_time_field_1.FormTimeField;
        case internal_settings_types_1.SimpleEasSettingInputType.JSON:
            return function Component(props) {
                return react_1.default.createElement(form_editor_1.FormEditor, Object.assign({}, props, { language: "json" }));
            };
        case internal_settings_types_1.SimpleEasSettingInputType.INTEGER:
            return function Component(props) {
                return react_1.default.createElement(form_text_field_1.FormTextField, Object.assign({}, props, { type: "number" }));
            };
        default:
            return form_text_field_1.FormTextField;
    }
};
//# sourceMappingURL=internal-settings-dialog.js.map